import { GlowEffect2D } from "../display/effect2d/GlowEffect2D";
import { ClassUtils } from "../utils/ClassUtils";
import { Filter } from "./Filter";
export class GlowFilter extends Filter {
    constructor(color, blur = 4, offX = 6, offY = 6) {
        super();
        this._effect2D = new GlowEffect2D(color, blur, offX, offY);
    }
    getEffect() {
        return this._effect2D;
    }
    get offY() {
        return this._effect2D.offsetY;
    }
    set offY(value) {
        this._effect2D.offsetY = value;
        this.onChange();
    }
    get offX() {
        return this._effect2D.offsetX;
    }
    set offX(value) {
        this._effect2D.offsetX = value;
        this.onChange();
    }
    get color() {
        return this._effect2D.color;
    }
    set color(value) {
        this._effect2D.color = value;
        this.onChange();
    }
    get blur() {
        return this._effect2D.blur;
    }
    set blur(value) {
        this._effect2D.blur = value;
        this.onChange();
    }
}
ClassUtils.regClass("GlowFilter", GlowFilter);
